import React, { createContext, useContext } from "react";

import { useNotifications } from "@/hooks"

type NotificationState = ReturnType<typeof useNotifications>;

const NotificationContext = createContext<NotificationState | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
   children,
}) => {

  // Memoised by the hook
  const notifications = useNotifications();

  return (
    <NotificationContext.Provider value={notifications}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotificationContext must be used within a NotificationProvider"
    );
  }
  return context;
};
